module.exports = __webpack_public_path__ + "img/img07.3b8afab2.png";